// История чата пользователя (хранится на сервере, синхрон между устройствами).

import { authHeaders, config } from '../config'
import { getAccessKey } from './access'

export interface StoredTurn {
  speaker: 'user' | 'agent'
  text: string
  agentId?: string
  ts?: number
}

function apiUrl(path: string): string {
  return config.apiBaseUrl ? config.apiBaseUrl + path : path
}

export async function fetchHistory(): Promise<StoredTurn[]> {
  try {
    const r = await fetch(apiUrl('/api/history'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ accessKey: getAccessKey() }),
    })
    if (!r.ok) return []
    const j = await r.json()
    return Array.isArray(j.turns) ? j.turns : []
  } catch {
    return []
  }
}

export async function clearHistory(): Promise<void> {
  try {
    await fetch(apiUrl('/api/history/clear'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ accessKey: getAccessKey() }),
    })
  } catch {
    /* noop */
  }
}
